import React from 'react';
import PropTypes from 'prop-types';
import { Card } from 'react-bootstrap';
import { formatAnswerDay } from '@/shared/utils/deadline';

// One history entry in plain words. A coordinator's edit names who made it
// and the fields it changed; the server never sends the values.
function describe(entry) {
    if (entry.event === 'coordinator_edited') {
        const who = entry.byName || 'A program coordinator';
        const fields = (entry.fields || []).join(', ');
        return fields
            ? `${who} changed ${fields}`
            : `${who} changed the request`;
    }
    if (entry.event === 'instructor_changed') {
        const who = entry.byName || 'Someone';
        if (!entry.toName) return `${who} removed the instructor of record`;
        return entry.fromName
            ? `${who} changed the instructor of record from ${entry.fromName} to ${entry.toName}`
            : `${who} named ${entry.toName} as the instructor of record`;
    }
    if (entry.event === 'meetings_updated') {
        const who = entry.byName || 'The faculty member';
        const fields = (entry.fields || []).join(' and ').toLowerCase();
        return fields
            ? `${who} updated the ${fields}`
            : `${who} updated the meeting details`;
    }
    if (entry.event === 'withdrawn') return 'Withdrawn';
    if (entry.event === 'reopened') return 'Reopened for revision';
    return null;
}

/**
 * The request's history as the server sent it to this viewer, oldest first:
 * withdrawals, reopenings, coordinators' edits and changes of instructor.
 */
function RequestHistory({ history }) {
    const lines = (history || [])
        .map((entry) => ({ entry, text: describe(entry) }))
        .filter(({ text }) => text);
    if (lines.length === 0) return null;
    return (
        <Card className="border-0 shadow-sm mb-4">
            <Card.Body>
                <h2 className="h5 mb-3">Request history</h2>
                <ul className="list-unstyled mb-0">
                    {lines.map(({ entry, text }, index) => (
                        <li key={index} className="mb-2">
                            <span className="text-muted me-2">
                                {formatAnswerDay(entry.at)}
                            </span>
                            <span className="text-break">{text}</span>
                        </li>
                    ))}
                </ul>
            </Card.Body>
        </Card>
    );
}

RequestHistory.propTypes = {
    history: PropTypes.arrayOf(
        PropTypes.shape({
            event: PropTypes.string,
            at: PropTypes.string,
            byName: PropTypes.string,
            fields: PropTypes.arrayOf(PropTypes.string),
            fromName: PropTypes.string,
            toName: PropTypes.string,
        })
    ),
};

export default RequestHistory;
